import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'i2a-user-nodata',
  templateUrl: './user-nodata.component.html',
  styleUrls: ['./user-nodata.component.scss']
})
export class UserNoDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
